import { EventEmitter } from '@angular/core';

export class Button {

    public marginTop: number = 0;

    constructor(public title: string, public isAction: boolean, public width: number, public clickHandler: Function = () => { }, public testId: string = "") {

    }
}